import { useStyles } from "./styles";

type PreviewHtmlProps = {
  link: string;
};

export function PreviewHtml({ link }: PreviewHtmlProps) {
  const styles = useStyles();
  return <iframe className={styles.root} src={link} title="preview-html" />;
}
